<template>
  <div>
    <modal v-show="isModalVisible" @close="closeModal" footer>
      <template v-slot:title>
        <h5>Create Card Request</h5>
      </template>
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label for="name">Account Number</label>
            <input
              type="text"
              class="form-control"
              :disabled="account_details != null"
              v-model="account_number"
              placeholder="Account Number"
            />
          </div>
        </div>
        <div v-if="step == 2">
          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              class="form-control"
              v-model="account_details.name"
              placeholder="Name"
              disabled
            />
          </div>
          <!-- select delivery type -->
          <div class="form-group">
            <label for="name">Delivery Method</label>
            <select
              name="delivery_method"
              v-model="delivery_method"
              class="form-control"
            >
              <option value="" selected>Please Select Delivery Method</option>
              <option value="pickup">Pickup</option>
              <option value="delivery">delivery</option>
            </select>
          </div>
          <div v-if="delivery_method == 'delivery'">
            <div class="form-group">
              <label for="name">Address</label>
              <input
                type="text"
                class="form-control"
                v-model="address"
                placeholder="Address"
              />
            </div>
            <div class="form-group">
              <label for="name">City</label>
              <input
                type="text"
                class="form-control"
                v-model="city"
                placeholder="City"
              />
            </div>
            <div class="form-group">
              <label for="state">State</label>
              <select name="state" v-model="state_id" class="form-control">
                <option value selected disabled>Select state</option>
                <option
                  :value="state.id"
                  v-for="state in states"
                  :key="state.id"
                  >{{ state.name }}</option
                >
              </select>
            </div>
            <div class="form-group">
              <label for="name">Phone Number</label>
              <input
                type="text"
                class="form-control"
                v-model="phone_number"
                placeholder="Phone Number"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="button"
          :disabled="formLoading"
          @click.prevent="formAction"
        >
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">{{
              step === 1 ? "Checking Account..." : "Requesting Card..."
            }}</span>
          </span>
          <span v-else>
            {{ step === 1 ? "Check Customer" : "Request Card" }}
          </span>
        </button>
        <button
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal"
        >
          Cancel
        </button>
      </template>
    </modal>
    <modal v-show="isBatchModalVisible" @close="closeBatchModal" footer>
      <template v-slot:title>
        <h5>Export Batch</h5>
      </template>
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label for="name">Date</label>
            <input
              type="date"
              class="form-control"
              v-model="batch_date"
              placeholder="Date"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="button"
          :disabled="formLoading"
          @click.prevent="performAction"
        >
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">
              Exporting Batch ...
            </span>
          </span>
          <span v-else>
            Export Batch
          </span>
        </button>
        <button
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeBatchModal"
        >
          Cancel
        </button>
      </template>
    </modal>
    <div
      v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>{{ loading_message }}</h3>
        </div>
      </div>
    </div>
    <div class=" card card--no-shadow">
      <div class="card-header">
        <div class=" row justify-content-between">
          <div class="col-auto">
            <slot name="header">
              <h4>SMS List</h4>
            </slot>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'SendSMS' }"
              class="button"
              v-if="permissions.includes('send-sms')"
            >
              Send SMS
            </router-link>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="card-body">
          <!-- <div class="col-md-12">
            <div class="card card--no-shadow card-profile">
              <div class="card-header">
                <h3 class="font-weight-600 mb-0">Filter Loan Report</h3>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="">Account Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="account_number_q"
                          placeholder="11111111111"
                          maxlength="11"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="name"
                          placeholder="11111111111"
                          maxlength="11"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <button
                        @click.prevent="getData(1)"
                        class="button mt-2"
                        :disabled="reportsLoading"
                      >
                        <span class="custom-loader" v-if="reportsLoading">
                          <loader-icon
                            size="1.5x"
                            class="custom-class"
                          ></loader-icon>
                          <span
                            style="font-weight: 600; text-transform: initial;"
                            >Fetching Loan Data...</span
                          >
                        </span>
                        <span v-else>
                          Filter
                        </span>
                      </button>
                      <button
                        @click.prevent="clearFilter()"
                        class="button  mt-2"
                        :disabled="reportsLoading"
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <CDataTable
            :items="cards"
            :fields="fields"
            :itemsPerPage="cards.length"
            pagination
            sorter
          >
            <template #date="{ item }">
              <td class="table--action-mobile">
                {{ item.created_at | date }}
              </td>
            </template>            
            <template #name="{ item }">
              <td class="table--action-mobile">
                <div v-if="item.user">
                  {{ item.user.first_name }} {{ item.user.last_name }}
                </div>                
              </td>
            </template>
          </CDataTable>
          <CPagination
            :activePage.sync="next_page"
            :pages="total"
            :onActivePageChange="onPageChange()"
          ></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import CPagination from "../../components/CPagination.vue";
import ApiService from "../../services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = [
  "name",
  "reference",
  "senderID",
  "no_of_phone_number",
  "batches",
  "delivered_batch",
  "status",
  "date",
];
export default {
  name: "CardsVue",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      loading_message: "Getting Card Request ready...",
      fields,
      account_number_q: "",
      name: "",
      isModalVisible: false,
      isBatchModalVisible: false,
      formLoading: false,
      loading: true,
      account_details: null,
      account_number: "",
      cards: [],
      states: [],
      step: 1,
      next_page: 1,
      total: 1,
      current: 1,
      delivery_method: "",
      address: "",
      city: "",
      phone_number: "",
      state_id: "",
      batch_date: "",
      reportsLoading: false
    };
  },
  methods: {
    clearFilter() {
      this.account_number_q = "";
      this.name = "";
      this.getData(1);
    },
    openModal() {
      this.isModalVisible = true;
      this.step = 1;
      this.account_number = "";
    },
    openBatchModal() {
      this.isBatchModalVisible = true;
      this.step = 1;
      this.account_number = "";
    },
    async getData(page) {
      this.closeModal;
      this.loading_message = "Getting SMS List...";
      this.loading = true;
      try {
        const res = await ApiService.get(`utility/sms-list?page=${page}`);
        console.log(res.data.data);

        this.cards = res.data.data.data;
        this.current = res.data.data.current_page;
        this.total = res.data.data.last_page;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response);
      }
    },
    async formAction() {
      if (this.step === 1) {
        this.getAccountDetails();
      } else {
        this.requestCard();
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        this.getData(this.next_page);
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.account_details = null;
      this.step = 1;
    },
    closeBatchModal() {
      this.isBatchModalVisible = false;
      this.batch_date = "";
    }
  },
  mounted() {
    this.getData(1);
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  }
};
</script>

<style scoped></style>
